import React, { useState, useEffect } from 'react';
import { Menu, X, ArrowUpRight } from 'lucide-react';

const navItems = [
  { label: 'Experience', href: '#experience' },
  { label: 'Process', href: '#process' },
  { label: 'HMO Specialism', href: '#specialism' },
  { label: 'Advantages', href: '#advantages' },
  { label: 'Ethos', href: '#ethos' },
  { label: 'Voices', href: '#voices' },
  { label: 'FAQ', href: '#faq' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'bg-[#0f0f10]/85 backdrop-blur-md border-b border-white/5' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-5 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3">
          <div className="bg-white/95 rounded-md px-3 py-1.5 shadow-sm">
            <img
              src="/assets/msr-logo.png"
              alt="MSR Residential Group"
              className="h-9 md:h-10 w-auto object-contain"
            />
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {navItems.map((item) => (
            <a key={item.label} href={item.href} className="nav-link text-sm tracking-wide">
              {item.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          className="hidden lg:inline-flex btn-primary px-5 py-2.5 rounded-full items-center gap-2 text-sm"
        >
          Book a Call
          <ArrowUpRight className="w-4 h-4" />
        </a>

        <button
          className="lg:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          aria-label="toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden bg-[#0f0f10] border-t border-white/5">
          <div className="px-6 py-6 flex flex-col gap-4">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={() => setOpen(false)}
                className="text-white/80 hover:text-[#e4cfaf] py-2 border-b border-white/5"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="btn-primary px-5 py-3 rounded-full inline-flex items-center justify-center gap-2 mt-2"
            >
              Book a Call <ArrowUpRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
